import { useState } from 'react'
import { toast } from 'sonner'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import ManualCharacterContextMenu from 'app/frontend/base/components/ManualCharacterContextMenu'
import { useClaimExistingManualCharacter } from 'app/frontend/base/config/mutations'
import CandidateCommentModal from './CandidateCommentModal'
import {
  useIsCandidateAdmin,
  useRemoveCandidate,
  useUpdateCandidate,
} from '../hooks'

type Props = {
  candidate: wowaudit.GuildCandidate
  size?: 'small' | 'medium'
}

const CandidateContextMenu = ({ candidate, size }: Props) => {
  const [commentOpen, setCommentOpen] = useState(false)
  const { mutate: update, isPending: updating } = useUpdateCandidate()
  const { mutate: remove, isPending: removing } = useRemoveCandidate()
  const { mutate: claim, isPending: claiming } =
    useClaimExistingManualCharacter()
  const isAdmin = useIsCandidateAdmin()
  const characterId = candidate.characterReference.id

  return (
    <>
      {commentOpen && (
        <CandidateCommentModal
          candidate={candidate}
          onClose={() => setCommentOpen(false)}
        />
      )}

      <ManualCharacterContextMenu
        character={candidate.characterReference}
        description={
          candidate.signedUpByOwner
            ? 'Signed up themselves'
            : 'Added by an admin'
        }
        size={size}
        busy={updating || removing || claiming}
        spec={{
          role: candidate.role,
          specId: candidate.specId,
          specDetails: candidate.specDetails,
          onChange: (specId) => update({ characterId, specId }),
          onRoleChange: (role) => update({ characterId, role, specId: null }),
        }}
        onClassChange={(characterClass) =>
          update({ characterId, characterClass, specId: null })
        }
        onRename={(values, onSuccess) =>
          update(
            { characterId, ...values },
            {
              onSuccess: () => {
                toast.success('Name changed')
                onSuccess()
              },
            },
          )
        }
        renaming={updating}
        removeLabel='Remove'
        onRemove={() => remove(characterId)}
      >
        <DropdownMenuItem onSelect={() => setCommentOpen(true)}>
          {candidate.comment ? 'Edit comment' : 'Add comment'}
        </DropdownMenuItem>
        {isAdmin && candidate.userId === null && (
          <DropdownMenuItem
            onSelect={() => claim(candidate.characterReference)}
          >
            Claim as mine
          </DropdownMenuItem>
        )}
      </ManualCharacterContextMenu>
    </>
  )
}

export default CandidateContextMenu
